import type { RequestClientAdminsBulkCreation } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { UserBulkCreationFormValues } from '../schema';

export const generateBulkCreationRequest = (
  data: UserBulkCreationFormValues
): RequestClientAdminsBulkCreation => ({
  file: data.file,
  selected_option: data.registrationType,
  scheduled_date: data.scheduledDate
    ? formatDate({ date: data.scheduledDate, formatType: 'yyyy-MM-dd' })
    : null,
  scheduled_hour: data.scheduledTime ?? null,
});
